import { createContext, useContext, useEffect, useRef, useState } from "react";

// Tracks whether the current page is the very first one rendered this
// session, so that first page can skip its enter fade (no delay before
// content appears) while every subsequent route change still animates
// normally. Deliberately NOT implemented via AnimatePresence's `initial`
// prop — that suppresses enter animations for the whole first-rendered
// subtree (including unrelated nested motion components, like in-page
// tab switches), not just the page-level fade.
const FirstLoadContext = createContext(true);

export function FirstLoadProvider({ locationKey, children }) {
	const firstKeyRef = useRef(locationKey);
	const [isFirstLoad, setIsFirstLoad] = useState(true);

	useEffect(() => {
		if (locationKey !== firstKeyRef.current) {
			setIsFirstLoad(false);
		}
	}, [locationKey]);

	return (
		<FirstLoadContext.Provider value={isFirstLoad}>
			{children}
		</FirstLoadContext.Provider>
	);
}

export function useIsFirstLoad() {
	return useContext(FirstLoadContext);
}

export const contentVariants = {
	hidden: {
		opacity: 0,
	},
	visible: {
		opacity: 1,
		transition: {
			delay: 0.75,
			duration: 0.75,
		},
	},
	exit: {
		opacity: 0,
		transition: {
			duration: 0.75,
		},
	},
};